import { Flex } from '@pancakeswap/uikit'
import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const Input = styled.input`
  background: transparent;
  border: none;
  outline: none;
  flex: 1 0 0;
  color: #fff;
  font-family: Satoshi;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 134%;
  transition: all 0.3s ease;

  ::placeholder {
    color: rgba(255, 255, 255, 0.6);
    transition: opacity 0.3s ease;
  }
`

export const SearchTypeFilterItemWrapper = styled(Flex)`
  display: flex;
  height: 24px;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  animation: ${fadeIn} 0.3s ease;

  :hover {
    opacity: 0.8;
  }
`

export const SearchTypeFilterItemText = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>`
  color: rgba(255, 255, 255, 0.6);
  font-family: 'SF Pro Rounded';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 2.4px;
  text-transform: uppercase;
  transition: color 0.3s ease;

  ${({ isActive }) =>
    isActive &&
    `
    color: #FFF;
  `};
`

export const ResultTypeGroupTitle = styled.span`
  color: rgba(255, 255, 255, 0.8);
  leading-trim: both;
  text-edge: cap;
  font-family: 'SF Pro Rounded';
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 2px;
  text-transform: uppercase;
`

export const SearchResultItem = styled(Flex)`
  display: flex;
  height: 32px;
  padding: 12px 0px;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  animation: ${fadeIn} 0.3s ease;
`

export const SearchResultItemText = styled.span`
  color: #fff;
  leading-trim: both;
  text-edge: cap;
  font-family: Satoshi;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 134%; /* 26.8px */
`

export const SearchResultItemDescription = styled.span`
  color: rgba(255, 255, 255, 0.7);
  leading-trim: both;
  text-edge: cap;
  font-family: Satoshi;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 134%; /* 21.44px */
`
